/* eslint-disable */
// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import Container from "@mui/material/Container";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Fade from '@mui/material/Fade';

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication layout components
import Footer from "layouts/authentication/components/Footer";

// Soft UI Dashboard PRO React page layout routes
import pageRoutes from "page.routes";
import { useState, useEffect } from "react";
import SkipToContent from "components/SkipToContent";
import usePageTitle from "utils/usePageTitle";

// Step components
import Step1DateIdentificare from "./steps/Step1DateIdentificare";
import Step2DetaliiSesizare from "./steps/Step2DetaliiSesizare";
import Step3ElementeSuplimentare from "./steps/Step3ElementeSuplimentare";
import ValidationStep from "./steps/ValidationStep";
import CompletionScreen from "./CompletionScreen";
import LoadingScreen from "./LoadingScreen";
import customColors, { primaryBtnSx, backBtnSx } from "./colors";
import {
  ADRESA_PATTERN,
  FIELD_LIMITS,
  MAX_AGE_YEARS,
  MIN_AGE_YEARS,
  MIN_PHONE_DIGITS,
  NUME_PATTERN,
  getMinBirthDate,
  isAtLeastYearsOld,
} from "./validation";

import useAPI from "../../../../utils/useApi";
import TurnstileWidget, { TURNSTILE_RESPONSE_FIELD } from "components/TurnstileWidget";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './customToast.css';

function FormularSesizare() {
  usePageTitle("Formular sesizare");
  // State management
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [codSesizare, setCodSesizare] = useState("");
  const [loading, setLoading] = useState(true);
  const [validationCode, setValidationCode] = useState("");
  const [validationError, setValidationError] = useState("");
  const [showValidation, setShowValidation] = useState(false);
  const [codTrimis, setCodTrimis] = useState(false);
  const [countdown, setCountdown] = useState(300); // 5 minute în secunde
  const [needsValidation, setNeedsValidation] = useState(false);
  const useApi = useAPI();
  const [complaintId, setComplaintId] = useState(null);
  const [complaintUuid, setComplaintUuid] = useState(null);
  const [files, setFiles] = useState([]);
  const [errors, setErrors] = useState({});
  
  const [formFetchData, setFormFetchData] = useState(null);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [turnstileResetKey, setTurnstileResetKey] = useState(0);
  // Form state
  const [formData, setFormData] = useState({
    nume: "",
    email: "",
    telefon: "",
    adresa: "",
    dataNasterii: null,
    confidential: false,
    subiect: "",
    descriere: "",
    tipIncident: "",
    vatamari: {
      fizica: false,
      materiala: false,
      psihica: false,
      niciuna: false
    },
    responsabil: "",
    locIncident: "",
    foreignSubmission: "",
    foreignSubmissionResponsible: "",
    foreignSubmissionOtherInstitution: "",
    dataFapte: null,
    tara: "Romania",
    judet: "",
    oras: "",
    locFapta: "",
    tipuriVatamareSuplimentar: "",
    acordGDPR: false
  });

  // Initial loading effect
  useEffect(() => {
    fetchFormData();
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);
    
    return () => clearTimeout(timer);
  }, []);

  // Countdown pentru codul de validare
  useEffect(() => {
    let timer;
    if (codTrimis && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (countdown === 0) {
      setCodTrimis(false);
      setValidationError("Codul de validare a expirat. Vă rugăm să solicitați un nou cod.");
    }
    return () => clearInterval(timer);
  }, [codTrimis, countdown]);

  // Form handlers
  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    
    if (type === "checkbox") {
      if (name.includes("vatamari.")) {
        const vatamare = name.split(".")[1];
        setFormData({
          ...formData,
          vatamari: {
            ...formData.vatamari,
            [vatamare]: checked
          }
        });
      } else {
        setFormData({
          ...formData,
          [name]: checked
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      dataFapte: date
    });
  };

  const handleDateNastereChange = (date) => {
    setFormData({
      ...formData,
      dataNasterii: date
    });
  };

  const fetchFormData = async () => {
    try {
      const response = await useApi.getComplaintFormData();
      setFormFetchData(response);
    } catch (error) {
      console.error("Error fetching form data:", error);
    }
  };

  const turnstileSiteKey = formFetchData?.turnstile_site_key;

  const handleTurnstileExpire = () => {
    setTurnstileToken(null);
    setTurnstileResetKey((key) => key + 1);
  };

  const handleSendForm = async () => {
    if (turnstileSiteKey && !turnstileToken) {
      toast.error("Vă rugăm să completați verificarea de securitate înainte de trimitere.");
      return;
    }

    try {
      const formDataToSend = new FormData();
      // append all fields from formData
      Object.entries(formData).forEach(([key, value]) => {
        if (key === "dataNasterii") {
          if (value) {
            // Format date to YYYY-MM-DD for the backend
            const date = new Date(value);
            if (!isNaN(date.getTime())) {
              const formatted = date.toISOString().split("T")[0];
              formDataToSend.append("date_of_birth", formatted);
            }
          }
          return;
        } else if (key === "responsabil") {
          // Skip "public_institution" value - not ready in backend yet
          if (value !== "public_institution") {
            formDataToSend.append(key, value);
          }
        } else if (key === "vatamari") {
          Object.entries(value).forEach(([k, v]) => formDataToSend.append(`vatamari[${k}]`, v));
        } else if (key === "locIncident") {
          // Map locIncident to incident_place_type for the backend
          formDataToSend.append("incident_place_type", value);
        } else if (key === "foreignSubmission") {
          formDataToSend.append("foreign_submission", value);
        } else if (key === "foreignSubmissionResponsible") {
          if (formData.foreignSubmission === "yes") {
            if (value === "other_institution" && formData.foreignSubmissionOtherInstitution) {
              // Send the custom institution name as foreign_submission_responsible
              formDataToSend.append("foreign_submission_responsible", formData.foreignSubmissionOtherInstitution);
            } else if (value !== "other_institution") {
              formDataToSend.append("foreign_submission_responsible", value);
            }
          }
        } else if (key === "foreignSubmissionOtherInstitution") {
          // Handled above via foreignSubmissionResponsible
          return;
        } else if (key === "tipuriVatamareSuplimentar") {
          // Trimitem doar dacă utilizatorul a completat ceva (câmp opțional)
          if (value && String(value).trim() !== "") {
            formDataToSend.append("tipuriVatamareSuplimentar", value);
          }
        } else if (key === "tara" || key === "judet" || key === "oras") {
          // Only send location fields if locIncident is "offline"
          if (formData.locIncident === "offline") {
            if (key === "tara") {
              formDataToSend.append("country", value);
            } else if (key === "judet") {
              formDataToSend.append("county", value);
            } else if (key === "oras") {
              formDataToSend.append("location_city", value);
            }
          }
          return;
        } else {
          formDataToSend.append(key, value);
        }
      });
      files.forEach(file => formDataToSend.append("files", file));
      if (turnstileToken) {
        formDataToSend.append(TURNSTILE_RESPONSE_FIELD, turnstileToken);
      }
      const res = await useApi.registerComplaintForm(formDataToSend);
      setComplaintId(res.id);
    } catch (error) {
      const data = error.response?.data;
      if (data) {
        if (Array.isArray(data.files)) {
          data.files.forEach((msg) => toast.error(msg));
        } else if (Array.isArray(data.detail)) {
          data.detail.forEach((msg) => toast.error(msg));
        } else if (typeof data.detail === "string") {
          toast.error(data.detail);
        } else if (typeof data.files === "string") {
          toast.error(data.files);
        } else {
          toast.error("A apărut o eroare la trimiterea formularului.");
        }
      } else {
        toast.error("A apărut o eroare la trimiterea formularului.");
      }
      setTurnstileToken(null);
      setTurnstileResetKey((key) => key + 1);
      throw error;
    }
  };

  // Validation function for Step 1
  const validateStep1 = () => {
    const newErrors = {};
    
    if (!formData.nume?.trim()) {
      newErrors.nume = "Numele și prenumele sunt obligatorii";
    } else if (formData.nume.length > FIELD_LIMITS.nume) {
      newErrors.nume = `Numele poate avea maximum ${FIELD_LIMITS.nume} de caractere`;
    } else if (!NUME_PATTERN.test(formData.nume)) {
      newErrors.nume = "Numele poate conține doar litere, cratimă și spații";
    }
    
    if (!formData.email?.trim()) {
      newErrors.email = "Adresa de email este obligatorie";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Adresa de email nu este validă";
    }
    
    if (!formData.telefon?.trim()) {
      newErrors.telefon = "Numărul de telefon este obligatoriu";
    } else if (!/^[0-9]+$/.test(formData.telefon)) {
      newErrors.telefon = "Numărul de telefon poate conține doar cifre";
    } else if (
      formData.telefon.length < MIN_PHONE_DIGITS ||
      formData.telefon.length > FIELD_LIMITS.telefon
    ) {
      newErrors.telefon = `Numărul de telefon trebuie să aibă între ${MIN_PHONE_DIGITS} și ${FIELD_LIMITS.telefon} cifre`;
    }
    
    if (!formData.adresa?.trim()) {
      newErrors.adresa = "Adresa fizică este obligatorie";
    } else if (formData.adresa.length > FIELD_LIMITS.adresa) {
      newErrors.adresa = `Adresa poate avea maximum ${FIELD_LIMITS.adresa} de caractere`;
    } else if (!ADRESA_PATTERN.test(formData.adresa)) {
      newErrors.adresa = "Adresa poate conține doar litere, cifre și semnele . , - / ' ( ) #";
    }
    
    // Check if dataNasterii is valid
    const isValidDate = formData.dataNasterii && 
                       formData.dataNasterii instanceof Date && 
                       !isNaN(formData.dataNasterii.getTime());
    
    if (!isValidDate) {
      newErrors.dataNasterii = "Data nașterii este obligatorie";
    } else if (formData.dataNasterii > new Date()) {
      newErrors.dataNasterii = "Data nașterii nu poate fi în viitor";
    } else if (!isAtLeastYearsOld(formData.dataNasterii, MIN_AGE_YEARS)) {
      newErrors.dataNasterii = `Trebuie să aveți cel puțin ${MIN_AGE_YEARS} ani pentru a depune o sesizare`;
    } else if (formData.dataNasterii < getMinBirthDate()) {
      newErrors.dataNasterii = `Data nașterii nu poate fi mai veche de ${MAX_AGE_YEARS} de ani`;
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Validation function for Step 2
  const validateStep2 = () => {
    const newErrors = {};
    
    if (!formData.subiect?.trim()) {
      newErrors.subiect = "Subiectul este obligatoriu";
    } else if (formData.subiect.length > FIELD_LIMITS.subiect) {
      newErrors.subiect = `Subiectul poate avea maximum ${FIELD_LIMITS.subiect} de caractere`;
    }
    
    if (!formData.descriere?.trim()) {
      newErrors.descriere = "Descrierea detaliată este obligatorie";
    } else if (formData.descriere.length > FIELD_LIMITS.descriere) {
      newErrors.descriere = `Descrierea poate avea maximum ${FIELD_LIMITS.descriere} de caractere`;
    }
    
    if (formData.tipuriVatamareSuplimentar?.length > FIELD_LIMITS.tipuriVatamareSuplimentar) {
      newErrors.tipuriVatamareSuplimentar = `Acest câmp poate avea maximum ${FIELD_LIMITS.tipuriVatamareSuplimentar} de caractere`;
    }
    
    if (!formData.tipIncident) {
      newErrors.tipIncident = "Tipul incidentului este obligatoriu";
    }
    
    if (!formData.vatamare) {
      newErrors.vatamare = "Tipul vătămării este obligatoriu";
    }
    
    if (!formData.responsabil) {
      newErrors.responsabil = "Câmpul 'Pe cine reclamați?' este obligatoriu";
    }

    if (!formData.locIncident) {
      newErrors.locIncident = "Locul incidentului este obligatoriu";
    }

    if (!formData.foreignSubmission) {
      newErrors.foreignSubmission = "Acest câmp este obligatoriu";
    }
    
    if (!formData.dataFapte) {
      newErrors.dataFapte = "Data faptelor este obligatorie";
    } else {
      // Check if dataFapte is valid and not in the future
      const isValidDate = formData.dataFapte instanceof Date && 
                         !isNaN(formData.dataFapte.getTime());
      
      if (!isValidDate) {
        newErrors.dataFapte = "Data faptelor nu este validă";
      } else if (formData.dataFapte > new Date()) {
        newErrors.dataFapte = "Data faptelor nu poate fi în viitor";
      }
    }
    
    // Validare pentru locul faptei în funcție de tipul incidentului
    if (formData.locIncident === "offline") {
      if (!formData.tara) {
        newErrors.tara = "Țara este obligatorie";
      }
      
      if (formData.tara === "Romania") {
        if (!formData.judet?.trim()) {
          newErrors.judet = "Județul este obligatoriu";
        }
        
        if (!formData.oras?.trim()) {
          newErrors.oras = "Localitatea este obligatorie";
        } else if (formData.oras.length > FIELD_LIMITS.oras) {
          newErrors.oras = `Localitatea poate avea maximum ${FIELD_LIMITS.oras} de caractere`;
        }
      }
    }
    
    if (formData.locIncident && !formData.locFapta?.trim()) {
      newErrors.locFapta = formData.locIncident === "online" 
        ? "Link-ul sau platforma este obligatorie" 
        : "Adresa detaliată este obligatorie";
    }
    
    // Files (dovezi) are no longer required
    // Removed validation: if (!files || files.length === 0)
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Validation function for Step 3
  const validateStep3 = () => {
    const newErrors = {};
    
    if (!formData.acordGDPR) {
      newErrors.acordGDPR = "Trebuie să fiți de acord cu prelucrarea datelor personale (GDPR)";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    // Validate current step
    let isValid = false;
    
    if (activeStep === 0) {
      isValid = validateStep1();
    } else if (activeStep === 1) {
      isValid = validateStep2();
    } else if (activeStep === 2) {
      isValid = validateStep3();
    }
    
    if (!isValid) {
      toast.error("Vă rugăm să completați toate câmpurile obligatorii marcate cu *");
      return;
    }
    
    // Clear errors if validation passed
    setErrors({});
    
    // Validate only on last step before sending
    if (activeStep === 2 && !needsValidation) {
      // Dacă suntem la ultimul pas și nu am validat încă, arătăm ecranul de validare
      setValidationError("");
      try {
        await handleSendForm(); // Trimiterea datelor formularului înainte de a trimite codul de validare
      } catch {
        return; // Nu avansăm dacă trimiterea a eșuat (eroarea e afișată în toast în handleSendForm)
      }
      setNeedsValidation(true);
      // Simulăm trimiterea codului pe email
      setCodTrimis(true);
      setCountdown(300); // Resetăm countdown-ul la 5 minute
    } else if (needsValidation) {
      // Dacă suntem în procesul de validare, nu facem nimic (se ocupă handleValidateCode)
      return;
    } else {
      // Altfel, trecem la pasul următor normal
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleValidationCodeChange = (e) => {
    setValidationCode(e.target.value);
  };

  const handleValidateCode = async () => {
    try {
      const res = await useApi.validateComplaintFormEmail({"complaint_form_id": complaintId, "code": validationCode});
      setCodSesizare(res.form_uuid)
      setNeedsValidation(false);
      if (activeStep === 2) {
        handleSubmit();
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } catch (error) {
      console.error("Error validating code:", error);
      setValidationError("A apărut o eroare la validarea codului. Vă rugăm să încercați din nou.");
      return;
    } 

    // if (validationCode === "123456") {
    //   setNeedsValidation(false);
    //   if (activeStep === 2) {
    //     handleSubmit();
    //   } else {
    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    //   }
    // } else {
    //   setValidationError("Codul de validare introdus este incorect. Vă rugăm să încercați din nou.");
    // }
  };

  const handleTrimiteCodNou = () => {
    setCodTrimis(true);
    setCountdown(300);
    setValidationError("");
  };

  const handleBack = () => {
    if (needsValidation) {
      setNeedsValidation(false);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    // Generate a unique code for the complaint
    // const uniqueCode = "SES" + Date.now().toString().slice(-8);
    
    // Simulate API call
    setTimeout(() => {
      // setCodSesizare(uniqueCode);
      setCompleted(true);
      setLoading(false);
    }, 1500);
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted(false);
    setCodSesizare("");
    setValidationCode("");
    setValidationError("");
    setShowValidation(false);
    setCodTrimis(false);
    setNeedsValidation(false);
    setTurnstileToken(null);
    setErrors({});
    setFormData({
      nume: "",
      email: "",
      telefon: "",
      adresa: "",
      dataNasterii: null,
      confidential: false,
      subiect: "",
      descriere: "",
      tipIncident: "",
      vatamari: {
        fizica: false,
        materiala: false,
        psihica: false,
        niciuna: false
      },
      responsabil: "",
      locIncident: "",
      foreignSubmission: "",
      foreignSubmissionResponsible: "",
      foreignSubmissionOtherInstitution: "",
      dataFapte: null,
      tara: "Romania",
      judet: "",
      oras: "",
      locFapta: "",
      tipuriVatamareSuplimentar: "",
      acordGDPR: false
    });
  };

  const steps = ['Date de identificare', 'Detalii sesizare', 'Elemente suplimentare'];

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Step1DateIdentificare
            formData={formData}
            handleChange={handleChange}
            handleDateNastereChange={handleDateNastereChange}
            customColors={customColors}
            errors={errors}
          />
        );
      case 1:
        return (
          <Step2DetaliiSesizare
            formData={formData}
            handleChange={handleChange}
            handleDateChange={handleDateChange}
            customColors={customColors}
            FormDataContent={formFetchData}
            files={files}
            setFiles={setFiles}
            errors={errors}
          />
        );
      case 2:
        return (
          <Step3ElementeSuplimentare
            formData={formData}
            handleChange={handleChange}
            customColors={customColors}
            errors={errors}
          />
        );
      default:
        return 'Unknown step';
    }
  };

  return (
    <PageLayout>
        <SkipToContent />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      <DefaultNavbar
        routes={pageRoutes}
        transparent
        action={{
          type: "external",
          route: "/formular-sesizare",
          label: "Trimite Sesizare",
          color: "info",
        }}
      />
      <SoftBox component="main" id="main-content" tabIndex={-1} sx={{ outline: "none" }} mt={19} mb={5}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={10}>
              <Fade in={true} timeout={800}>
                <Card sx={{ overflow: 'hidden', boxShadow: '0 20px 27px 0 rgba(0, 0, 0, 0.05)' }}>
                  <SoftBox 
                    p={3} 
                    textAlign="center" 
                    sx={{ 
                      background: customColors.gradient.header,
                      color: "white",
                    }}
                  >
                    <SoftTypography variant="h3" fontWeight="bold" color="white">
                      Formular de Sesizare
                    </SoftTypography>
                    <SoftTypography variant="body1" color="white" opacity={0.8}>
                      Completați formularul pentru a trimite o sesizare sau petiție
                    </SoftTypography>
                  </SoftBox>

                  
                  {loading ? (
                    <LoadingScreen customColors={customColors} />
                  ) : !completed ? (
                    <>
                      <SoftBox 
                        py={2} 
                        mb={1}
                        sx={{
                          px: { xs: 0, sm: 3 }
                        }}
                      >
                        <Stepper 
                          activeStep={activeStep} 
                          alternativeLabel
                          sx={{
                            "& .MuiStepLabel-root .Mui-completed": {
                              color: customColors.secondary.main,
                            },
                            "& .MuiStepLabel-root .Mui-active": {
                              color: customColors.primary.main,
                              fontWeight: 700,
                            },
                            "& .MuiStepIcon-root.Mui-active": {
                              color: customColors.primary.main,
                            },
                            "& .MuiStepIcon-root.Mui-completed": {
                              color: customColors.secondary.main,
                            },
                          }}
                        >
                          {steps.map((label) => (
                            <Step key={label}>
                              <StepLabel>{label}</StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </SoftBox>
                      
                      <Divider />
                      
                      {codTrimis ? (
                        <ValidationStep
                          email={formData.email}
                          countdown={countdown}
                          validationCode={validationCode}
                          validationError={validationError}
                          handleCodeChange={handleValidationCodeChange}
                          handleValidateCode={handleValidateCode}
                          handleTrimiteCodNou={handleTrimiteCodNou}
                          customColors={customColors}
                        />
                      ) : getStepContent(activeStep)}

                      {activeStep === steps.length - 1 && !codTrimis && turnstileSiteKey && (
                        <SoftBox px={3} pb={2} display="flex" justifyContent="center">
                          <TurnstileWidget
                            key={`turnstile-submit-${turnstileResetKey}`}
                            siteKey={turnstileSiteKey}
                            onVerify={setTurnstileToken}
                            onExpire={handleTurnstileExpire}
                            onError={handleTurnstileExpire}
                          />
                        </SoftBox>
                      )}
                      
                      <SoftBox p={3} display="flex" justifyContent="space-between">
                        <SoftButton
                          variant="contained"
                          disabled={activeStep === 0 || codTrimis}
                          onClick={handleBack}
                          startIcon={<Icon>arrow_back</Icon>}
                          sx={backBtnSx}
                        >
                          Înapoi
                        </SoftButton>
                        
                        {!codTrimis && (
                          activeStep === steps.length - 1 ? (
                            <SoftButton 
                              variant="contained"
                              onClick={handleNext}
                              disabled={turnstileSiteKey && !turnstileToken}
                              endIcon={<Icon>send</Icon>}
                              sx={primaryBtnSx}
                            >
                              Trimite sesizarea
                            </SoftButton>
                          ) : (
                            <SoftButton 
                              variant="contained"
                              onClick={handleNext}
                              endIcon={<Icon>arrow_forward</Icon>}
                              sx={primaryBtnSx}
                            >
                              Continuă
                            </SoftButton>
                          )
                        )}
                      </SoftBox>
                    </>
                  ) : (
                    <CompletionScreen
                      codSesizare={codSesizare}
                      email={formData.email}
                      handleReset={handleReset}
                      customColors={customColors}
                    />
                  )}
                </Card>
              </Fade>
            </Grid>
          </Grid>
        </Container>
      </SoftBox>
      {/* Disclaimer răspunsuri */}
      <SoftBox
        sx={{
          maxWidth: "900px",
          mx: "auto",
          px: { xs: 2, md: 0 },
          mb: 2,
          display: "flex",
          alignItems: "flex-start",
          gap: 1.5,
        }}
      >
        <Icon sx={{ color: "#5a6b85", fontSize: "1rem !important", mt: "2px", flexShrink: 0 }}>campaign</Icon>
        <SoftTypography variant="caption" sx={{ color: "#5a6b85", lineHeight: 1.6 }}>
          Platforma StopRasism nu se substituie procedurilor legale în vigoare. Răspunsurile la petițiile depuse prin această platformă vor fi comunicate, <strong>în primul rând</strong>, direct de către <strong>instituția competentă</strong> care a soluționat petiția. Ele vor fi transmise și prin intermediul platformei.
        </SoftTypography>
      </SoftBox>

      {/* Disclaimer 112 */}
      <SoftBox
        sx={{
          maxWidth: "900px",
          mx: "auto",
          px: { xs: 2, md: 0 },
          mb: 4,
          display: "flex",
          alignItems: "flex-start",
          gap: 1.5,
        }}
      >
        <Icon sx={{ color: "#5a6b85", fontSize: "1rem !important", mt: "2px", flexShrink: 0 }}>info</Icon>
        <SoftTypography variant="caption" sx={{ color: "#5a6b85", lineHeight: 1.6 }}>
          Urgențele <strong>nu</strong> pot fi semnalate prin intermediul acestui site. Dacă situația dumneavoastră reprezintă o urgență, <strong>vă rugăm apelați 112</strong>.
        </SoftTypography>
      </SoftBox>

      <Footer />
    </PageLayout>
  );
}

export default FormularSesizare;
